<template>
    <div class="banner">

        <div class="banner__main-image">
          <img src="@/assets/images/banner.jpg" />
        </div>

        <div class="banner__message">
            <balloon-message 
                :title="$t('cta.title')"
                :subtitle="$t('cta.description')"
            />
        </div>

    </div>
</template>

<script>
    import BalloonMessage from '@/components/BalloonMessage.vue';
    
    export default {
        components: {
            BalloonMessage
        }
    }
</script>

<style lang="scss" scoped>
@import '@/assets/variables';

    .banner {

        min-height: calc(100vh - 5rem);

        @media (max-width: $breakpoint-large) {
            min-height: calc(100vh - 3.125rem);
        }

        &__main-image {

            /* &:after {
                content:'';
                position:absolute;
                left:0;
                width:100%; height:100%;
                display:inline-block;
                background: linear-gradient(to bottom, rgba(255,255,255,.5) 0%,rgba(255,255,255,.0) 100%); 
            } */

            > img {
                width: 100%;
                height: 100%;
                left: 0;
                position: absolute;
                z-index: -1;
                object-fit: cover;
                object-position: top center;
            }

        }

        &__message {
            padding: 225px 100px;

            @media (max-width: $breakpoint-large) {
                display: flex;
                padding: 225px 0;
                text-align: center;
                justify-content: center;
                margin: 0 2rem;
            }
        }
        
    }

</style>